import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import axios from 'axios';
import {Label, Input} from 'reactstrap';
import {API_ROOT} from '../../api-config';
import Cookies from 'js-cookie';
import Swal from 'sweetalert2'

class Login extends Component {

    constructor(props) {
        super(props);

        this.state = {
            driver_num: "",
            processing: false
        };
    }

    validateForm() {
        return this.state.driver_num.length > 0;
    }

    handleChange = event => {
        this.setState({
            [event.target.id]: event.target.value
        });
    }

    handleSubmit = async event => {
        if (typeof event != "undefined") {
            event.preventDefault();
        }
        this.setState({
            processing: true
        });
        var self = this;
        axios.defaults.withCredentials = true;
        axios.post(`${API_ROOT}/driver/send-link`, {withCredentials: true, driver_num: this.state.driver_num})
            .then(function (response) {
                if (response.data.message == "OK") {
                    Swal("Success", "A text message with your login link has been sent", "success");
                    self.setState({processing: false});
                } else {
                    Swal("Error", response.data.message, "danger");
                    self.setState({processing: false});
                }
            })
            .catch(function (error) {
                self.setState({
                    processing: false
                });
                Swal("Error", (error.response && error.response.data && (error.response.data.message || error.response.data.Message)) || 'Request failed', "error");
            });
    }

    render() {
        return (
            <div className="block-center mt-4 wd-xl">
                <div className="card card-flat">
                    <div className="card-header text-center bg-dark">
                        <a href="">
                            <img className="block-center rounded" src="img/logo.svg" alt="Logo"/>
                        </a>
                    </div>
                    <div className="card-body">
                        <p className="text-center py-2">DRIVER PORTAL</p>
                        <form className="mb-3" id="loginForm" onSubmit={this.handleSubmit}>
                            <div className="form-group">
                                <label className="mb-0">Driver Number:</label>
                                <div className="input-group with-focus">
                                    <input className="form-control border-right-0" id="driver_num" type="number" placeholder="Enter Your Driver Number" autoComplete="off"
                                           onChange={this.handleChange}
                                           required/>
                                    <div className="input-group-append">
                                        <span className="input-group-text fa fa-envelope text-muted bg-transparent border-left-0"></span>
                                    </div>
                                </div>
                            </div>
                            <button className="btn btn-block btn-primary mt-3" type="submit" disabled={!this.validateForm() || this.state.processing}>
                                <span className={(this.state.processing ? "d-none" : "")}>Next</span>
                                <i className={(this.state.processing ? "fa fa-spinner fa-spin" : "d-none")}></i>
                            </button>
                        </form>
                    </div>
                </div>
                <div className="p-3 text-center">
                    <span className="mr-2">&copy;</span>
                    <span>2026</span>
                    <span className="mx-2">-</span>
                    <span>Greenhaven Transportation</span>
                </div>
            </div>
        );
    }
}

export default Login;
